import { CheckoutState } from "modules/checkout";
import { useSelector } from "react-redux";

export const useCheckout = () =>
  useSelector(({ checkout }: { checkout: CheckoutState }) => checkout);
